<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ method === "post" ? "Add" : "Edit" }} Offer</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="offer"
          :method="method"
          :action="url"
          @submitted="$emit('changed', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-input name="name" label="Name" />

                <custom-select
                  name="fee_type_id"
                  class="form-group"
                  label="Fees Type"
                  :items="transactionFeesTypes"
                />

                <custom-select
                  name="duration_iso"
                  label="Duration"
                  :items="durationOptions"
                  hint="Leave empty for no expiration"
                  persistent-hint
                  clearable
                />

              </v-col>

              <v-col cols="12">
                <custom-button block color="primary">
                  <v-icon v-if="method === 'post'">mdi-plus</v-icon>
                  <v-icon v-else>mdi-pencil</v-icon>
                  {{ method === "post" ? "Add" : "Edit" }}
                </custom-button>
              </v-col>
            </v-row>

          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    offer: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      feeTypes: [],
      key: 1,
      durationOptions: [
        { value: 'P1Y', text: '1 Year' },
        { value: 'P6M', text: '6 Months' },
        { value: 'P3M', text: '3 Months' },
        { value: 'P1M', text: '1 Month' },
      ],
    };
  },
  //   watch: {
  //     isActive() {
  //       this.key++;
  //     },
  //   },
  created() {
    this.fetchData();
  },
  computed: {
    transactionFeesTypes() {
      return this.getSelectOptions(this.feeTypes);
    },

    url() {
      if (this.offer && this.offer.id) {
        return `api/v1/transactions/feeConfigurations/${this.$route.params.id}/offer/${this.offer.id}`;
      }
      return `api/v1/transactions/feeConfigurations/${this.$route.params.id}/offer`;
    },
  },
  methods: {
    getSelectOptions(data) {
      return data.map(({ id, name }) => ({ value: id, text: name }));
    },
    fetchData() {
      this.$http.get("/api/v1/transactions/feeTypes").then((types) => {
        this.feeTypes = types.data;
      });
    },
  },
};
</script>
